const index = () => {
  return <h1>BST</h1>
}

export default index
